import React from "react";
import Styles from "./styles";

export default function BannerImg() {
  return <Styles></Styles>;
}
